<script lang="ts">
    import type { Logger, LogLine } from "..";
    import { persistedWritable, getEntries } from "..";
    import { onMount } from "svelte";

    export let logger: Logger;

    const { filter: filterStore, levels } = logger;

    function filter(line: LogLine) {
        return $visibleLevels[line.level as keyof typeof $visibleLevels].enabled;
    }

    function updateFilter() {
        filterStore.set(filter as any);
        $visibleLevels = $visibleLevels;
    }

    onMount(() => {
        filterStore.set(filter as any);
    });

    const visibleLevels = persistedWritable(
        "filter-log-levels",
        levels.reduce(
            (acc, level) => {
                acc[level] = {
                    enabled: true,
                };
                return acc;
            },
            {} as Record<string, { enabled: boolean }>
        )
    );
</script>

<!----------------------------------------------------------------------------->

<div class="controls">
    <div>
        {#each getEntries($visibleLevels) as [name, options]}
            <label>
                {name}
                <input type="checkbox" bind:checked={options.enabled} on:change={updateFilter} />
            </label>
        {/each}
    </div>
</div>

<!----------------------------------------------------------------------------->

<style>
    .controls {
        display: flex;
        flex-direction: row;
        gap: 1em;
        user-select: none;
    }
</style>
